
import { createRoutine } from "redux-saga-routines";

export const getLiveStreams = createRoutine('GET_LIVE_STREAMS');